import { messageContentSchema, messageRequestSchema } from './api';

// Re-export the schemas from api.ts
export const messageSchema = messageRequestSchema;

// Re-export the type
export type MessageFormData = typeof messageRequestSchema._type;
